import { TrashIcon } from "vega-icons";

import { type DealDataRoom } from "@vega-api/generated/types/dealDataRoom";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";

type DataRoomProviderCardProps = {
  dataRoom: DealDataRoom;
  onEdit: (dataRoom: DealDataRoom) => void;
  onRemove: (dataRoom: DealDataRoom) => void;
  readOnly?: boolean;
};

export const DataRoomProviderCard = ({
  dataRoom,
  onEdit,
  onRemove,
  readOnly = false,
}: DataRoomProviderCardProps) => (
  <div className="flex items-center flex-wrap justify-between md:flex-nowrap gap-4 p-4 bg-primary border border-border rounded-md">
    <h3 className="body-base-semibold text-text/primary shrink-0 w-full md:min-w-48 md:max-w-64 truncate">
      {dataRoom.dataRoomProvider.displayName}
    </h3>

    {dataRoom.dataRoomUrl ? (
      <a
        className="body-small-regular text-text/secondary underline truncate block grow"
        href={dataRoom.dataRoomUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        {dataRoom.dataRoomUrl}
      </a>
    ) : null}

    {readOnly ? null : (
      <div className="flex items-center gap-2 shrink-0">
        <ThemedButton
          className="min-h-7 h-9 px-3"
          dataTestId={`remove-${dataRoom.dataRoomProvider.name}-button`}
          icon={<TrashIcon className="size-4" />}
          onClick={() => onRemove(dataRoom)}
          size="small"
          variant="secondary"
        />
        <ThemedButton
          className="min-h-7 h-9 px-3"
          dataTestId={`edit-${dataRoom.dataRoomProvider.name}-button`}
          onClick={() => onEdit(dataRoom)}
          size="small"
          variant="secondary"
        >
          {m.btn_edit()}
        </ThemedButton>
      </div>
    )}
  </div>
);
